import { useState } from 'react';
import { cancelGuestTicket } from 'src/apis/utils/ticket/ticket';

import CancelFailed from './CancelFailed';
import * as S from './ModalStyle';

interface ModalProps {
  onClose: () => void;
  reservationNumber: string;
  refetchTickets: () => void;
  openModal: (modalName: string) => void;
}

export default function CancelConfirm({
  onClose,
  reservationNumber,
  refetchTickets,
  openModal,
}: ModalProps) {
  // const navigate = useNavigate();
  const [showErrorModal, setShowErrorModal] = useState(false);

  const handleCancelReservation = async () => {
    try {
      await cancelGuestTicket(reservationNumber);
      await refetchTickets();
      onClose(); // 모달 닫기
      openModal('CancelComplete');
    } catch (err) {
      setShowErrorModal(true);
    }
  };

  return (
    <S.ModalOverlay>
      <S.ModalContainer>
        <S.ModalTitle>예약 취소</S.ModalTitle>
        <S.ModalContent>
          <S.Summary>
            사전예약을 취소하시면,
            <br /> 이후에는 되돌릴 수 없습니다.
          </S.Summary>
          <S.Summary>
            다시 한번 확인 후
            <br />
            &quot;예약 취소&quot; 버튼을 눌러주세요
          </S.Summary>
          <S.AskMethod>
            *입장권 관련 문의: <br />
            <a
              href="https://pf.kakao.com/_Ixexiwn"
              style={{ textDecoration: 'underline' }}
            >
              https://pf.kakao.com/_Ixexiwn
            </a>
          </S.AskMethod>
        </S.ModalContent>
        {/* 돌아가기 및 예약취소 버튼 */}
        <S.ButtonContainer>
          <S.SubButton onClick={onClose}>돌아가기</S.SubButton>
          <S.MainButton onClick={handleCancelReservation}>
            예약 취소
          </S.MainButton>
        </S.ButtonContainer>
      </S.ModalContainer>
      {showErrorModal && (
        <CancelFailed onClose={() => setShowErrorModal(false)} />
      )}
    </S.ModalOverlay>
  );
}
